/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as settingActions from "../../actions/settingActions";
import * as homePageActions from "../../actions/homePageActions";
import { Container, Navbar, Nav, NavDropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import * as userActions from "../../actions/userActions";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../utils/agent";
import { getSubdomainPath, handleConfirmLogout } from "../../utils/helpers";
import { imgPath } from "../../utils/imagePath";
import LogoutModal from "../../utils/LogoutModal";
import { IoMdLogOut } from "react-icons/io";


document.getElementById("OnscrollBody").onscroll = function () {
  const element = document.getElementById("navbar_scroll_fixed");
  const scroll = window.scrollY;
  if (scroll <= 20 && element) {
    element.classList.remove("fixed-top");
  } else if (element) {
    element.classList.add("fixed-top");
  }
};

function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("chatbodyclass");
}

const Index = (props) => {

  const { actions, community, setting } = props;
  const location = useLocation();
  const userInfo = useSelector((state) => state.userInfo);

  useEffect(() => {
    const fetchData = () => {
      actions.loadCommunityData(20);
    };
    fetchData();
  }, [actions]);

  const moduleRenderData = setting?.module_data;

  const isSectionShow = (name) => {
    return moduleRenderData?.some((item) => item?.name == name && item?.status == "Enabled" && item?.is_default == "Yes")
  }

  let headerPrevent = ["/login", "/forgotPassword", "/register", "/ignite-women-mentoring", "/mentee-signup-step-1", "/mentee-signup-step-2", "/mentee-signup-step-3", "/reset-password"];

  useEffect(() => {
    // userInfo (readable cookie)
    const userTokenCookie = getCookie("userID");

    if (userTokenCookie) {
      const userInfo = JSON.parse(userTokenCookie);
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    }
  }, []);

  useEffect(() => {
    const userInfo = Cookies.get("userInfo");
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      console.log(parsed);
    }
  }, []);

  const getCookie = (name) => {
    const cookies = document.cookie.split("; ");
    for (let c of cookies) {
      const [key, value] = c.split("=");
      if (key === name) return decodeURIComponent(value);
    }
    return null;
  };

  const dispatch = useDispatch();

  const [ssoLoading, setSsoLoading] = useState(false);

  const fetchFusionAuthAPI = createAsyncThunk(
    "fusionAuth/fetchData",
    async (_, { rejectWithValue }) => {
      try {
        setSsoLoading(true);
        const response = await agent.get(
          `${process.env.REACT_APP_NODE_SERVER_URL}/login`,
          {
            withCredentials: true, // important for cookies
            headers: {
              "x-node-domain": process.env.REACT_APP_SUBDOMAIN || "test", // Pass subdomain to Node server
            },
          }
        );
        const url = response?.data?.result?.url;

        if (!url) {
          throw new Error("Authorize URL not received from server");
        }

        // 🔥 Browser redirect (NOT fetch)
          globalThis.location.assign(url);

      } catch (error) {
        setSsoLoading(false);
        return rejectWithValue(
          error?.response?.data?.message || error.message
        );
      }
    }
  );

  useEffect(() => {
    if (
      setting?.is_sso_enable === "1" &&
      !userInfo?.id
      // && !alreadyRedirected
    ) {
      sessionStorage.setItem("sso_redirected", "1");
      dispatch(fetchFusionAuthAPI());
    }
  }, [setting?.is_sso_enable, userInfo?.id, dispatch]);

  const subDomainPath = getSubdomainPath();

  // Logout modal state and handlers (use common modal)
  const [showModal, setShowModal] = useState(false);
  const handleLogOut = () => setShowModal(true);
  const handleCloseLogoutModal = () => setShowModal(false);

  return (
    <>
      {['/partnerships']?.includes(location.pathname) && ['?is_mobile=yes'].includes(location.search) ? null :
        <header id="navbar_scroll_fixed" className={setting?.site_maintenance_notification ? "navigation-marque" : "navigation"}>

          {!headerPrevent?.includes(location.pathname) && (
            <Navbar expand="lg">
              <Container>
                <Link to="/" className="logo m-0">
                  <img
                    src={setting?.logo_path}
                    alt={setting?.name}
                    style={(subDomainPath === "essecuat" || subDomainPath === "essec" || subDomainPath === "uat")
                      ? { maxWidth: "200px", maxHeight: "59px" } : {}
                    }

                  />
                </Link>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="mx-md-auto align-items-lg-center d-flex">
                    {isSectionShow('Mentoring Engagement') && (
                      <NavLink
                        className="nav-link"
                        to="/mentors"
                        exact
                        activeClassName="active"
                      >
                        View All Mentors
                      </NavLink>
                    )}

                    {isSectionShow('Communities') && community.length > 0 && (
                      <NavDropdown title="Communities" id="basic-nav-dropdown">
                        {community.map((item, key) => (
                          <NavDropdown.Item
                            as={Link}
                            to={`/community-details/${item.slug}`}
                            key={item.id}
                          >
                            {item.group_name}
                          </NavDropdown.Item>
                        ))}
                      </NavDropdown>
                    )}
                    {isSectionShow('Resource Hub') && (
                      <NavLink
                        className="nav-link"
                        to="/resource-hub/all-posts"
                        exact
                        activeClassName="active"
                      >
                        Resources
                      </NavLink>
                    )}
                    {isSectionShow('Events') && (
                      <NavLink
                        className="nav-link"
                        to="/event/upcoming"
                        exact
                        activeClassName="active"
                      >
                        Events
                      </NavLink>
                    )}
                    {/* ) } */}
                    {/* {isSectionShow('Site Content') && ( */}
                    {setting?.about_us_enable === "1" && (
                      <NavLink
                        className="nav-link"
                        to="/about-us"
                        exact
                        activeClassName="active"
                      >
                        {setting?.menu_html}
                      </NavLink>
                    )}
                  </Nav>
                  <div className="header_login d-flex ">
                    {(!userInfo?.id && setting?.is_sso_enable == 1) ? (
                      // <button onClick={() => dispatch(fetchFusionAuthAPI())}
                      //   className="btn btn_join me-2"
                      // >
                      //   SSO Login
                      // </button>
                      <></>
                    ) : (!userInfo?.id) && (
                      <Link
                        to="/login"
                        className="btn btn_login me-2"
                      >
                        Login
                      </Link>
                    )}
                    {userInfo.id && userInfo?.role_id && (subDomainPath === 'siddev' || subDomainPath === 'siduat' || subDomainPath === 'sid') ? (
                      <Link to="/manage-profile" className="btn btn_join me-2">
                        My Dashboard
                      </Link>
                    ) : (userInfo.id && userInfo?.role_id && (
                      <Link to="/manage-profile" className="btn btn_join me-2">
                        My Profile
                      </Link>
                    ))}

                    {isSectionShow('Forum') && (
                      <Link
                        to="/forum"
                        className="btn btn_join ms-2"
                        style={{ minWidth: "auto" }}
                      >
                        Forum
                      </Link>
                    )}

                    {userInfo.id && userInfo?.role_id && (
                      <>
                        <div className="user_sub-info d-flex align-items-center" style={{ marginLeft: "10px" }}>
                          <div className="mail_notification d-flex align-items-center">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={<Tooltip id="tooltip-message">Message</Tooltip>}
                            >
                              <Link to="/chat" onClick={SidebarRemoveClass}>
                                <img
                                  src={imgPath + "message_icon.png"}
                                  alt="how to find a career mentor"
                                />
                              </Link>
                            </OverlayTrigger>
                          </div>
                          {/* Only the logout icon, using common modal */}
                          <div className="logout_notification mail_notification d-flex align-items-center ms-3 ">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={<Tooltip id="tooltip-logout">Logout</Tooltip>}
                            >
                              <Link onClick={handleLogOut} >
                                <IoMdLogOut className="" style={{ color: "var(--themeBlueHover)" }} />
                              </Link>
                            </OverlayTrigger>
                          </div>
                        </div>
                        <LogoutModal
                          show={showModal}
                          onClose={handleCloseLogoutModal}
                          onConfirm={() => handleConfirmLogout(actions, setShowModal, setting?.is_sso_enable == 1)}
                          logoPath={setting?.logo_path}
                        />
                      </>
                    )}
                  </div>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          )}
        </header >
      }
      {ssoLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <i
            className="fas fa-spinner fa-spin"
            style={{
              fontSize: "60px",
              color: "#ffffff",
            }}
          />
        </div>
      )}
    </>
  );
};

Index.propTypes = {
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),

  community: PropTypes.arrayOf(PropTypes.object).isRequired,

  actions: PropTypes.shape({
    loadCommunityData: PropTypes.func.isRequired,
    sendEmailForVerification: PropTypes.func.isRequired,
  }).isRequired,

  setting: PropTypes.shape({
    is_sso_enable: PropTypes.string.isRequired,
    about_us_enable: PropTypes.string.isRequired,
    module_data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        status: PropTypes.string,
        is_default: PropTypes.string,
      })
    ),
    site_maintenance_notification: PropTypes.bool,
    logo_path: PropTypes.string,
    name: PropTypes.string,
    about_me: PropTypes.string,
    menu_html: PropTypes.string,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    setting: state.setting,
    community: state.community,
    isAuth: state.isAuth,
    userInfo: state.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...userActions, ...settingActions, ...homePageActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
